import React from "react";
import { Row, Col, Container, Media } from "reactstrap";
import Slider from "react-slick";
import myImage from '../../../resources/custom/images/customer_testimonial.jpg';
import OneImage from '../../../resources/themeContent/images/testimonial/sophia.jpg';
import TwoImage from '../../../resources/themeContent/images/testimonial/1.jpg';
import ThreeImage from '../../../resources/themeContent/images/testimonial/4.jpg';


var settings = {
  autoplay: false,
  autoplaySpeed: 2500,
};

const Review = [
  {
    img: OneImage,
    user: "Sophia Martinez",
    review:
      "“I recently switched to Alderberry Medtech’s surgical needles in our OR. The ULTRAPASS coating makes insertion so much smoother than what we had before — noticeably less trauma to tissue and quicker sutures. It’s seriously upgraded our workflow.”"
  },
  {
    img: TwoImage,
    user: "Arjun Mehta",
    review:
      "“As a dental surgeon, I’m very particular about needle geometry and sharpness. The Alderberry Medtech dental suture needles have exceeded expectations: clean cuts, minimal barb-drag, and very consistent performance. My patients heal with less irritation.”"
  },
  {
    img: ThreeImage,
    user: "Emily Johnson",
    review:
      "“Customer service was excellent. When I needed a specialized curved bone needle for an ortho case, they helped me find exactly the right size, shipped fast, and I was able to do the procedure without the delays I often see with other suppliers.”"
  }
];

const CustomerTestimonial = () => {
  return (
    <>
      <section className="testimonial testimonial-inverse">
        <Container>
          <Row>
            <Col md="12">
              <div className="slide-1 no-arrow">
                <Slider {...settings}>
                  {Review.map((data, i) => (
                    <div key={i}>
                      <div className="testimonial-contain">
                        <div className="media">
                          <div className="testimonial-img">
                            <Media src={data.img} className="img-fluid rounded-circle" alt="testimonial" />
                          </div>
                          <div className="media-body">
                            <h5>{data.user}</h5>
                            <p>{data.review}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CustomerTestimonial;
